import { useState, useCallback } from 'react';
import { DeliveryHistoryFilter } from '../types/deliveryHistory.types';
import { loadFilters } from '@/shared/utils/filterStorage';
import { getDefaultDateRange } from '@/shared/utils/dateDefaultUtils';

export const FILTER_STORAGE_KEY = 'deliveryHistoryFilters';

export const useDeliveryFilter = (isSupplierUser: boolean, userId: string | null) => {
    const { startDate: defaultStartDate, endDate: defaultEndDate } = getDefaultDateRange();

    const [filter, setFilter] = useState<DeliveryHistoryFilter>(() => {
        const saved = loadFilters<DeliveryHistoryFilter>(FILTER_STORAGE_KEY);
        return (
            saved || {
                startDate: defaultStartDate,
                endDate: defaultEndDate,
                status: '',
                partnerId: isSupplierUser ? userId || '' : '',
            }
        );
    });

    const [searchedFilter, setSearchedFilter] = useState<DeliveryHistoryFilter | null>(null);

    const handleFilterChange = useCallback((newFilter: Partial<DeliveryHistoryFilter>) => {
        setFilter((prev) => ({ ...prev, ...newFilter }));
    }, []);

    return {
        filter,
        setFilter,
        searchedFilter,
        setSearchedFilter,
        handleFilterChange,
        defaultStartDate,
        defaultEndDate,
    };
};
